import React from 'react';
import UsersTable from './SortableTable';

export default function UsersScreen() {
  return <UsersTable />;
}
